import React from 'react';
import FormFieldsRenderer from "../../../../m3/_legacy_components/form-fields-renderer";

function isDisabled(field) {
    // if has disabled key, then use that, otherwise use can_edit
    const has_key = field?.disabled !== undefined;
    return has_key ? field.disabled : !field.can_edit;
}

function getNestedOption(field, key = 'options', fb) {
    // may be from input_props
    return field?.input_props?.[key] || field?.[key] || fb;
}

export const buildCustomFields = (fields,community,my_profile) => {
console.log("buildCustomFields",fields)
    return fields.map((field, k) => {
        return {
            label: field.label,
            type: field.type,
            accessor: field.accessor,

            disabled: isDisabled(field),
            placeholder: field?.placeholder||"",

            locked: field?.is_locked,

            footer_hint: field.hint||"",

            input_props: {
                community_uid: field?.input_props?.community_uid || field?.community_uid || community.id,
                required: getNestedOption(field, 'required', false),
                options: getNestedOption(field, 'options', {}),
                placeholder: getNestedOption(field, 'placeholder', "")
            }
        }
    })
}

export function EditMemberCustomFields({data, fields, fill, community, onChange, section}) {

    function handleOnChange(accessor, new_value, old_value, field) {
        onChange(accessor, new_value, old_value, field)
    }

    const my_profile = data?.id === community?.member_id;

    const render_fields = buildCustomFields(fields,community, my_profile);

    return <div className="space-y-3 pb-4" id="edit-custom-fields">
        <FormFieldsRenderer fill={fill} onChange={handleOnChange} data={data} fields={render_fields}/>
    </div>
}